export default __webpack_public_path__ + "static/media/chess.011c8c16.png";